export default __webpack_public_path__ + "static/media/gallery_01.6f34ee5e.jpg";